import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  useProjectPurchaseInvoiceDataTable,
} from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { Status } from 'modules/finance/components/Invoices/Status'

import { Amount } from '../../Amount'

interface ProjectPurchaseInvoiceDataTableProps {
  projectId: number
}

export const ProjectPurchaseInvoiceDataTable: React.FC<ProjectPurchaseInvoiceDataTableProps> = ({
  projectId,
}) => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const source = useProjectPurchaseInvoiceDataTable(
    [
      {
        kind: ProjectionKind.Custom,
        identifier: 'vendor',
        title: i18n.t('project_management.spending.table.headers.vendor'),
        template: '{{vendor.legalName}}',
        width: 200,
        colSpan: 3,
        render: ({ vendor }) => {
          return (
            <Box minWidth="s200">
              <Text.Normal overflowWrap>{vendor?.legalName}</Text.Normal>
            </Box>
          )
        },
      },
      {
        kind: ProjectionKind.Custom,
        identifier: 'documentNumber',
        title: i18n.t('project_management.spending.table.headers.document_number'),
        template: '{{documentNumber}}',
        render: ({ documentNumber }) => {
          return (
            <Box minWidth="s200">
              <Text.Normal overflowWrap>{documentNumber}</Text.Normal>
            </Box>
          )
        },
      },
      {
        kind: ProjectionKind.Custom,
        identifier: 'status',
        title: i18n.t('project_management.spending.table.headers.status'),
        template: '{{status}}',
        sortBy: 'status',
        render: ({ status }) => {
          return <Status status={status} />
        },
      },
      {
        kind: ProjectionKind.Custom,
        identifier: 'name',
        title: i18n.t('project_management.spending.table.headers.amount'),
        template: '{{currency}} {{ totalAmountCents | divided_by: 100}}',
        sortBy: 'totalAmountCents',
        render: ({ currency, totalAmountCents }) => {
          return <Amount amount={Number(totalAmountCents) || 0} currency={currency || 'EUR'} />
        },
      },
      {
        kind: ProjectionKind.Custom,
        identifier: 'documentDate',
        title: i18n.t('project_management.spending.table.headers.document_date'),
        template: '{{documentDate}}',
        sortBy: 'documentDate',
        render: ({ documentDate }) => {
          return (
            <Text.Normal overflowWrap>
              {documentDate ? dateBackendDateTimeToUI(documentDate) : '-'}
            </Text.Normal>
          )
        },
      },
    ],
    {
      variables: { companyId, projectId },
    }
  )

  return (
    <Box paddingTop="s64">
      <DataTable.Provider source={source} sort={{ path: 'totalAmountCents' }}>
        <DataTable.Table autoWidth />
      </DataTable.Provider>
    </Box>
  )
}
